// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-popup-wrapper {
  z-index: 1000;
}
.login-popup-wrapper .login-popup-container {
  z-index: 1001;
  max-width: 375px;
  box-shadow: 0px 4px 50px 48px rgba(0, 0, 0, 0.2509803922);
  padding: 20px;
  gap: 40px;
  border-radius: 20px;
}
.login-popup-wrapper .login-popup-container .close-btn {
  right: 10px;
  top: 10px;
  color: black;
}
@media screen and (min-width: 786px) {
  .login-popup-wrapper .login-popup-container .close-btn {
    right: -20px;
    top: -30px;
    color: white;
  }
}
@media screen and (max-width: 786px) {
  .login-popup-wrapper .login-popup-container {
    flex-direction: column;
    align-items: center;
    overflow: auto;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Popups/LoginPopup/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,gBAAA;EACA,yDAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AACJ;AACI;EACE,WAAA;EACA,SAAA;EACA,YAAA;AACN;AACM;EALF;IAMI,YAAA;IACA,UAAA;IACA,YAAA;EAEN;AACF;AAEE;EACE;IACE,sBAAA;IACA,mBAAA;IACA,cAAA;IACA,gBAAA;EAAJ;AACF","sourcesContent":[".login-popup-wrapper {\n  z-index: 1000;\n\n  .login-popup-container {\n    z-index: 1001;\n    max-width: 375px;\n    box-shadow: 0px 4px 50px 48px #00000040;\n    padding: 20px;\n    gap: 40px;\n    border-radius: 20px;\n\n    .close-btn {\n      right: 10px;\n      top: 10px;\n      color: black;\n\n      @media screen and (min-width: 786px) {\n        right: -20px;\n        top: -30px;\n        color: white;\n      }\n    }\n  }\n\n  @media screen and (max-width: 786px) {\n    .login-popup-container {\n      flex-direction: column;\n      align-items: center;\n      overflow: auto;\n      border-radius: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
